exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "prize-list .name-column {\n  width: 30%; }\n\nprize-list .prize-name-column {\n  width: 25%; }\n\nprize-list .prize-title-column {\n  width: 25%; }\n\nprize-list .prize-money-column {\n  width: 20%; }\n\nprize-list .column-header {\n  width: 100%;\n  text-align: left;\n  font-weight: bold; }\n  prize-list .column-header.money-column-header {\n    text-align: right; }\n\nprize-list .column-body {\n  width: 100%;\n  text-align: left; }\n  prize-list .column-body.money-column-body {\n    text-align: right; }\n\nprize-list .toyota {\n  font-family: 'Toyota' !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/prize-list/prize-list.component.scss
// module id = ../../../../../src/app/component-module/prize-list/prize-list.component.scss
// module chunks = main